<script>
import ProductService from '@/services/product'
import { productColor } from '@/utils/product'

export default {
  props: {
    products: {
      type: Array,
      default: function() {
        return [];
      }
    },
    loadProducts: {
      type: Function
    }
  },
  data() {
    return {
      showModal: false,
      productToRemove: '',
    };
  },
  methods: {
    productColor,
    removeProduct() {
      this.$bvModal.hide('modal-remove');      

      ProductService.removeProduct(this.productToRemove._id).then(() => {
        this.loadProducts(false);
        this.$toast.open('Produto excluído');
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao excluir o produto');
      })
    },
    inactiveProduct(product) {
      let loader = this.$loading.show();

      const data = {
        _id: product._id,
        active: false,
      }

      ProductService.saveProduct(data).then(() => {
        loader.hide();
        product.active = false;

        this.$toast.open('Produto inativado')
      }).catch((err) => {
        this.$toast.error(err);
        loader.hide();
      })
    },
    activeProduct(product) {
      let loader = this.$loading.show();

      const data = {
        _id: product._id,
        active: true,
      }

      ProductService.saveProduct(data).then(() => {
        loader.hide();
        product.active = true;

        this.$toast.open('Produto ativado')
      }).catch((err) => {
        this.$toast.error(err);
        loader.hide();
      })
    }
  }
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table table-centered">
      <thead class="thead-light">
        <tr>
          <th>Produto</th>
          <th>Código SKU</th>
          <th>Descrição</th>
          <th>Status</th>
          <th>Estoque</th>
          <th>Preço</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="data in products" :key="data._id">
          <td>
            <img
              v-bind:src="data.image"
              alt="product-img"
              title="product-img"
              class="avatar-md"
            />
          </td>
          <td>{{data.sku}}</td>
          <td>
            {{data.description}}
            <p class="text-muted mb-0 mt-1 font-size-10" v-if="productColor(data)">Cor: {{productColor(data)}}</p>
            <p class="text-muted mb-0 mt-1 font-size-10">{{data.categories}}</p>
          </td>
          <td>
            <span
              class="badge badge-pill badge-soft-primary font-size-12"
              :class=" {
                'badge-soft-primary': data.active === true,
                'badge-soft-secondary': data.active === false,
              }"
            >{{data.active ? 'Ativo' : 'Inativo'}}</span>
          </td>
          <td>{{data.stock}}</td>
          <td>
            <p class="text-muted mb-0 font-size-10" v-if="data.price_from">de {{data.price_from | currency}}</p>
            {{data.price | currency}}
          </td>
          <td>
            <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
              <template v-slot:button-content>
                <i class="mdi mdi-dots-horizontal font-size-18"></i>
              </template>

              <router-link class="dropdown-item" :to="'/products/edit/' + data._id">
                <i class="fas fa-pencil-alt text-success mr-2 mt-2"></i> Editar
              </router-link>

              <b-dropdown-item v-if="data.active" @click="inactiveProduct(data)">
                <i class="fas fa-pause text-warning mr-2 mt-2"></i> Inativar
              </b-dropdown-item>

              <b-dropdown-item v-if="!data.active" @click="activeProduct(data)">
                <i class="fas fa-play text-success mr-2 mt-2"></i> Ativar
              </b-dropdown-item>

              <b-dropdown-divider></b-dropdown-divider>
              
              <b-dropdown-item v-b-modal.modal-remove @click="productToRemove = data">
                <i class="fas fa-trash-alt text-danger mr-2 mt-2"></i> Excluir
              </b-dropdown-item>    
            </b-dropdown>
          </td>
        </tr>
      </tbody>
    </table>

    <b-modal
      id="modal-remove"
      title="Excluir Produto?"
      title-class="font-18"
      centered
    >
      <p>Confirma a exclusão do produto?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-remove')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="primary" @click="removeProduct">Excluir</b-btn>
      </div>
    </b-modal>
  </div>  
</template>

<style lang="scss">
  .avatar-md {
    object-fit: contain;
  }

  .font-size-10 {
    font-size: 10px
  }
</style>